import React from 'react';
import * as Styled from './SecondaryNav.styles';
import SecondaryNavItem from './SecondaryNavItem';
import { useSelectUserContext } from '../../selectors/userContext.selectors';
import { InnovyzeRole, isMinimumRole } from '../../utils';
export default function SecondaryNavItems({ items, changeTab, index, tabSecondary, applyPadding, className, onlyShowSeveralTabs = false, }) {
    const { innovyzeRole, entitlements } = useSelectUserContext();
    const meetsGatingCriteria = (item) => {
        const itemMinRole = item?.minimumRole || InnovyzeRole.READ_ONLY;
        const itemEntitlements = item?.gatedEntitlements;
        return (isMinimumRole(innovyzeRole, itemMinRole) ||
            (itemEntitlements &&
                itemEntitlements.some(entitlement => entitlements.includes(entitlement))));
    };
    const getAllowedTabs = React.useMemo(() => {
        const allowedTabs = [];
        items.forEach((item, i) => {
            if (meetsGatingCriteria(item)) {
                allowedTabs.push(React.createElement(SecondaryNavItem, { changeTab: changeTab, active: i === index, index: i, item: item, key: i }));
            }
        });
        return allowedTabs;
    }, [innovyzeRole, items]);
    const shouldShowTabs = onlyShowSeveralTabs
        ? items.length > 1
        : !!items.length;
    return (items && (React.createElement(Styled.NavBar, { applyPadding: applyPadding, className: className },
        React.createElement(Styled.Tabs, null, shouldShowTabs && getAllowedTabs),
        tabSecondary && (React.createElement(Styled.TabSecondary, null, tabSecondary)))));
}
